/* DentPDR chrome elements: announcement bar, sticky header, mega menu, mobile menu, predictive search. Needs dp-global.js (window.DP). */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const { lockScroll, unlockScroll, trapFocus } = window.DP;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const wide = matchMedia('(min-width: 1024px)');
  const esc = (s) => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  const vis = (el) => el.getClientRects().length > 0;
  const define = (name, cls) => customElements.get(name) || customElements.define(name, cls);


  define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      const wrap = this.closest('[data-dp-header-wrap]'), root = document.documentElement;
      let flow = 0, ticking = false;
      const setH = () => root.style.setProperty('--dp-header-h', this.offsetHeight + 'px');
      const measure = () => {
        const was = this.hasAttribute('data-compact');
        this.removeAttribute('data-compact');
        flow = this.offsetHeight;
        if (wrap) wrap.style.setProperty('--dp-header-flow', flow + 'px');
        this.toggleAttribute('data-compact', was);
        setH();
      };
      const update = () => {
        ticking = false;
        const compact = scrollY > (wrap || this).getBoundingClientRect().top + scrollY + flow;
        if (compact === this.hasAttribute('data-compact')) return;
        this.toggleAttribute('data-compact', compact);
        setH();
        emit('dp:header:compact', { compact });
      };
      const refresh = () => { measure(); update(); };
      refresh();
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      addEventListener('resize', refresh);
      if (document.fonts) document.fonts.ready.then(refresh);
      /* cart badge, bump and the add confirmation shown when the drawer could not refresh (D10) */
      const badge = q('[data-dp-cart-count]', this), link = q('[data-dp-cart-link]', this), added = q('[data-dp-added]', this);
      let bump, pop;
      document.addEventListener('dp:cart:updated', (e) => {
        const d = e.detail || {};
        if (!badge || typeof d.itemCount !== 'number') return;
        const before = parseInt(badge.textContent, 10) || 0;
        badge.textContent = d.itemCount;
        badge.hidden = d.itemCount === 0;
        if (link) link.setAttribute('aria-label', d.itemCount === 1 ? link.dataset.labelOne : link.dataset.labelMany.replace('7', d.itemCount));
        if (d.itemCount > before) {
          badge.setAttribute('data-bump', ''); clearTimeout(bump);
          bump = setTimeout(() => badge.removeAttribute('data-bump'), 2200);
        }
        if (d.drawer === false && added) { added.hidden = false; clearTimeout(pop); pop = setTimeout(() => { added.hidden = true; }, 2200); }
      });
    }
  });

  /* page dimming under the mega menu and the search dropdown */
  const scrim = (show) => {
    const s = q('[data-dp-scrim]'), h = q('[data-dp-header]');
    if (!s || !h) return;
    if (show) s.style.setProperty('--dp-scrim-top', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
    s.hidden = !show;
  };

  define('mega-menu', class extends HTMLElement {
    connectedCallback() {
      const triggers = qa(`[aria-controls="${this.id}"]`), hoverOk = matchMedia('(hover: hover)');
      let hoverT, leaveT, byHover = false;
      const open = (viaHover) => {
        clearTimeout(leaveT);
        if (!this.hidden) return;
        document.dispatchEvent(new CustomEvent('dp:mega:open', { detail: this }));
        byHover = viaHover; this.hidden = false;
        // sit under the visible trigger, kept inside the header (shortcut: LTR only, mirror with right for RTL)
        const t = triggers.find(vis), box = this.parentElement.getBoundingClientRect();
        if (t) this.style.left = Math.max(16, Math.min(t.getBoundingClientRect().left - box.left - 12, box.width - this.offsetWidth - 16)) + 'px';
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
        scrim(true);
      };
      const close = (focus) => {
        clearTimeout(hoverT);
        if (this.hidden) return;
        const active = triggers.find(vis);
        this.hidden = true;
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        scrim(false);
        if (focus && active) active.focus();
      };
      const leave = () => { if (hoverOk.matches && !this.hidden) { clearTimeout(leaveT); leaveT = setTimeout(close, 200); } };
      triggers.forEach((t) => {
        t.addEventListener('click', () => { if (!this.hidden && byHover) byHover = false; else if (this.hidden) open(false); else close(); });
        t.addEventListener('mouseenter', () => { if (hoverOk.matches) { clearTimeout(leaveT); hoverT = setTimeout(() => open(true), 150); } });
        t.addEventListener('mouseleave', () => { clearTimeout(hoverT); leave(); });
      });
      this.addEventListener('mouseenter', () => clearTimeout(leaveT));
      this.addEventListener('mouseleave', leave);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) { e.preventDefault(); close(true); } });
      document.addEventListener('click', (e) => { if (!this.hidden && !this.contains(e.target) && !triggers.some((t) => t.contains(e.target))) close(); });
      document.addEventListener('focusin', (e) => { if (e.target.matches('[data-dp-ps-input]')) close(); });
      document.addEventListener('dp:header:compact', () => close());
      document.addEventListener('dp:mega:open', (e) => { if (e.detail !== this) close(); });
      const sc = q('[data-dp-scrim]');
      if (sc) sc.addEventListener('click', () => close());
    }
  });

  define('mobile-menu', class extends HTMLElement {
    connectedCallback() {
      const panel = q('.dp-mm__panel', this), levels = qa('[data-dp-level]', this);
      let release, trigger, isOpen = false;
      const level = (n) => {
        levels.forEach((l) => { l.hidden = l.dataset.dpLevel !== String(n); });
        const f = q(n === '2' ? '.dp-mm__back' : '[data-dp-level-open="2"]', this);
        if (f) f.focus();
      };
      const open = (btn) => {
        if (isOpen) return;
        isOpen = true; trigger = btn;
        this.hidden = false;
        levels.forEach((l, k) => { l.hidden = k !== 0; });
        requestAnimationFrame(() => this.setAttribute('data-open', ''));
        btn.setAttribute('aria-expanded', 'true');
        lockScroll(); release = trapFocus(panel, null);
        q('[data-dp-menu-close]', panel).focus();
        emit('dp:overlay:change', { open: true });
      };
      const close = (restore) => {
        if (!isOpen) return;
        isOpen = false;
        this.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
        release(); unlockScroll();
        if (restore !== false) trigger.focus();
        emit('dp:overlay:change', { open: false });
        setTimeout(() => { if (!isOpen) this.hidden = true; }, reduce.matches ? 0 : 260);
      };
      document.addEventListener('click', (e) => {
        const o = e.target.closest('[data-dp-menu-open]');
        if (o) return open(o);
        if (!isOpen || !this.contains(e.target)) return;
        const l = e.target.closest('[data-dp-level-open]');
        if (e.target.closest('[data-dp-menu-close]')) close();
        else if (e.target.closest('[data-dp-search-open]')) close(false);
        else if (l) level(l.dataset.dpLevelOpen);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen) { e.preventDefault(); close(); } });
      wide.addEventListener('change', () => { if (wide.matches) close(false); });
    }
  });

  define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url, popular = (this.dataset.popular || '').split(',').map((s) => s.trim()).filter(Boolean);
      const status = q('[data-dp-ps-status]', this), tpl = (n) => q(`[data-dp-ps-tpl=${n}]`, this).content.cloneNode(true);
      const overlay = q('[data-dp-ps-overlay]', this), dd = q('[data-dp-ps-body="desktop"]', this);
      const inputs = {}; qa('[data-dp-ps-input]', this).forEach((i) => { inputs[i.dataset.dpPsInput] = i; });
      const bodies = { desktop: dd, mobile: q('[data-dp-ps-body="mobile"]', this) };
      let timer, ctrl, last = '', release, trigger, overlayOpen = false;
      const mode = () => (overlayOpen || !wide.matches ? 'mobile' : 'desktop');
      const expanded = (v) => Object.values(inputs).forEach((i) => { i.setAttribute('aria-expanded', v); if (!v) i.removeAttribute('aria-activedescendant'); });
      const chips = (el) => { el.innerHTML = popular.map((t) => `<button class="dp-ps__chip" type="button" data-dp-ps-run="${esc(t)}">${esc(t)}</button>`).join(''); };
      const popularState = () => {
        bodies.mobile.replaceChildren(tpl('popular'));
        chips(q('.dp-ps__chips', bodies.mobile)); expanded(false);
      };
      const openDropdown = () => {
        if (!dd.hidden) return;
        const fr = dd.parentNode.getBoundingClientRect(), row = dd.closest('.dp-header__row'), rr = row.getBoundingClientRect();
        const pad = parseFloat(getComputedStyle(row).paddingInlineStart) || 40, w = Math.min(880, innerWidth - pad * 2);
        dd.style.insetInlineStart = Math.max(pad, Math.min(fr.left, innerWidth - pad - w)) - rr.left + 'px';
        dd.style.insetBlockStart = fr.bottom - rr.top + 8 + 'px';
        dd.hidden = false; scrim(true);
      };
      const closeDropdown = () => { if (dd.hidden) return; dd.hidden = true; dd.innerHTML = ''; scrim(false); expanded(false); };
      const show = (m, html) => {
        const body = bodies[m];
        body.innerHTML = html; body.setAttribute('aria-busy', 'false');
        if (m === 'desktop') openDropdown();
        const list = q('[role=listbox]', body);
        if (list) { list.id = 'dp-ps-list-' + m; inputs[m].setAttribute('aria-controls', list.id); }
        qa('[data-dp-option]', body).forEach((o, n) => { o.id = `dp-ps-opt-${m}-${n}`; });
        expanded(!!list);
      };
      const search = (term) => {
        if (ctrl) ctrl.abort();
        const m = mode(), c = (ctrl = new AbortController());
        last = term;
        let timedOut = false;
        const to = setTimeout(() => { timedOut = true; c.abort(); }, 8000);
        bodies[m].replaceChildren(tpl('loading'));
        const label = q('[data-dp-searching]', bodies[m]);
        label.textContent = label.dataset.dpSearching.replace('{terms}', term);
        bodies[m].setAttribute('aria-busy', 'true');
        if (m === 'desktop') openDropdown();
        fetch(`${url}?q=${encodeURIComponent(term)}&resources[type]=product,collection,article&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search`, { signal: c.signal })
          .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then((html) => {
            clearTimeout(to);
            const res = q('[data-dp-psr]', new DOMParser().parseFromString(html, 'text/html'));
            if (!res) throw new Error('empty');
            show(m, res.outerHTML);
            const hint = q('[data-dp-ps-hint]', bodies[m]);
            if (hint && popular.length) {
              hint.textContent = hint.dataset.template.replace('{first}', popular[0]).replace('{second}', popular[1] || popular[0]);
              chips(q('[data-dp-ps-chips]', bodies[m]));
              qa('.dp-ps__chip', bodies[m]).slice(2).forEach((b) => b.remove());
            }
            if (status) status.textContent = q('[data-dp-psr]', bodies[m]).dataset.count || '';
          })
          .catch((err) => {
            clearTimeout(to);
            if (err.name === 'AbortError' && !timedOut) return;
            bodies[m].replaceChildren(tpl('error'));
            bodies[m].setAttribute('aria-busy', 'false'); expanded(false);
            if (m === 'desktop') openDropdown();
          });
      };
      const onInput = (m) => {
        const input = inputs[m], term = input.value.trim();
        qa('[data-dp-ps-clear]', input.closest('.dp-search')).forEach((b) => { b.hidden = !input.value; });
        clearTimeout(timer);
        if (term.length < 2) { if (ctrl) ctrl.abort(); if (m === 'desktop') closeDropdown(); else popularState(); return; }
        timer = setTimeout(() => search(term), 250);
      };
      Object.keys(inputs).forEach((m) => {
        const input = inputs[m];
        input.addEventListener('input', () => onInput(m));
        input.addEventListener('focus', () => { if (m === 'desktop' && dd.hidden && dd.innerHTML) openDropdown(); });
        input.addEventListener('keydown', (e) => {
          const opts = qa('[data-dp-option]', bodies[m]), cur = opts.findIndex((o) => o.getAttribute('aria-selected') === 'true');
          if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && opts.length) {
            e.preventDefault();
            const n = e.key === 'ArrowDown' ? (cur + 1) % opts.length : (cur <= 0 ? opts.length - 1 : cur - 1);
            opts.forEach((o, k) => o.setAttribute('aria-selected', k === n));
            input.setAttribute('aria-activedescendant', opts[n].id);
            opts[n].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'Enter' && cur > -1) { e.preventDefault(); location.href = opts[cur].href; }
          else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (m === 'desktop') closeDropdown(); else this.closeOverlay(); }
        });
      });
      this.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-dp-ps-clear]'), run = e.target.closest('[data-dp-ps-run]');
        if (clear) { const i = q('input', clear.closest('.dp-search')); i.value = ''; i.focus(); onInput(i.dataset.dpPsInput); }
        else if (run) { const i = inputs[mode()]; i.value = run.dataset.dpPsRun; i.focus(); onInput(i.dataset.dpPsInput); clearTimeout(timer); search(i.value.trim()); }
        else if (e.target.closest('[data-dp-ps-retry]')) search(last);
        else if (e.target.closest('[data-dp-ps-close]')) this.closeOverlay();
      });
      this.addEventListener('focusout', () => { if (!overlayOpen) setTimeout(() => { if (!this.contains(document.activeElement)) closeDropdown(); }, 0); });
      document.addEventListener('click', (e) => { if (!dd.hidden && !this.contains(e.target)) closeDropdown(); });
      const sc = q('[data-dp-scrim]');
      if (sc) sc.addEventListener('click', closeDropdown);
      this.openOverlay = (btn) => {
        if (overlayOpen) return;
        overlayOpen = true; trigger = btn;
        overlay.hidden = false; lockScroll(); release = trapFocus(overlay, null);
        popularState(); inputs.mobile.focus();
        emit('dp:overlay:change', { open: true });
      };
      this.closeOverlay = () => {
        if (!overlayOpen) return;
        overlayOpen = false; overlay.hidden = true;
        if (ctrl) ctrl.abort();
        release(); unlockScroll(); expanded(false);
        if (trigger) trigger.focus();
        emit('dp:overlay:change', { open: false });
      };
      document.addEventListener('click', (e) => {
        const b = e.target.closest('[data-dp-search-open]');
        if (!b) return;
        if (wide.matches) inputs.desktop.focus(); else setTimeout(() => this.openOverlay(b.closest('mobile-menu') ? null : b), 0);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlayOpen) { e.preventDefault(); this.closeOverlay(); } });
      wide.addEventListener('change', () => { if (wide.matches) this.closeOverlay(); });
    }
  });

  // country and language popover sits under its button, right-aligned (shortcut: LTR only)
  // measured on click, which runs before the popover opens, so the button is laid out and visible
  const locPop = document.getElementById('dp-loc-pop'), locBtn = q('[popovertarget="dp-loc-pop"]');
  if (locPop && locBtn) {
    locBtn.addEventListener('click', () => {
      const b = locBtn.getBoundingClientRect();
      locPop.style.top = `${b.bottom + 8}px`;
      locPop.style.right = `${Math.max(16, document.documentElement.clientWidth - b.right)}px`;
    });
    addEventListener('resize', () => { if (locPop.matches(':popover-open')) locPop.hidePopover(); });
    document.addEventListener('dp:header:compact', () => { if (locPop.matches(':popover-open')) locPop.hidePopover(); });
  }

})();
